import { DataGrid } from "@mui/x-data-grid";
import { useEffect } from "react";
import { Box, Paper, Stack } from "@mui/material";
import LinkButton from "../buttons/linkButton.component";
import { Add, Delete } from "@mui/icons-material";
import SearchInput from "../searchInput/searchInput.component";
import { useBreakpoint } from "../../hook/useBreakpoint";
import FormActionButton from "../buttons/formActionButton.component";

const DataGridComponent = ({
  onRowCountChange,
  rows,
  columns,
  buttonHref,
  buttonLabel,
  showButton = false,
  inputPlaceholder,
  onSearchChange,
  marginTop,
  loading = false,
  onRowSelectionModelChange,
  rowSelectionModel,
  checkboxSelection = false,
  showBulkDeleteButton,
  onBulkDeleteClick,
}) => {
  const breakpoint = useBreakpoint();
  useEffect(() => {
    onRowCountChange?.(rows?.length);
  }, [onRowCountChange, rows?.length]);

  return (
    <Paper
      sx={{
        paddingY: 2,
        paddingX: 4,
        width: "100%",
        overflowX: "auto",
        marginTop: marginTop,
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: breakpoint.isSm || breakpoint.isXs ? "column" : "row",
          gap: 2,
          width: "100%",
          marginBottom: 2,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <SearchInput placeholder={inputPlaceholder} onSearch={onSearchChange} />
        <Stack
          direction={breakpoint.isSm || breakpoint.isXs ? "column" : "row"}
          spacing={2}
        >
          {showButton && (
            <LinkButton icon={<Add />} href={buttonHref} label={buttonLabel} />
          )}
          {showBulkDeleteButton && (
            <FormActionButton
              startIcon={<Delete />}
              variant="outlined"
              label="Elimina strumenti"
              color="error"
              onClick={onBulkDeleteClick}
            />
          )}
        </Stack>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
        }}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pagination: { paginationModel: { pageSize: 5, page: 0 } },
        }}
        pagination
        pageSizeOptions={[5, 10, 20]}
        checkboxSelection={checkboxSelection}
        disableRowSelectionOnClick
        localeText={{
          noRowsLabel: "Nessun elemento trovato",
          MuiTablePagination: {
            labelRowsPerPage: "Elementi per pagina:",
            labelDisplayedRows: ({ from, to, count }) =>
              `${from}-${to} di ${count}`,
          },
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#F6F6F6",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
        }}
      />
    </Paper>
  );
};

export default DataGridComponent;
